import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import CrashScreen from './components/CrashScreen';
import { applyTheme, loadTheme } from './lib/themes';
import { initAnalytics } from './lib/analytics';
import { initErrorTracking } from './lib/errorTracking';

// Apply the persisted theme before first paint to avoid a flash of the default.
applyTheme(loadTheme());

// Before render, so a crash during the first paint is still captured.
// No-op unless VITE_SENTRY_DSN is set.
initErrorTracking();

// No-op unless VITE_UMAMI_WEBSITE_ID is set, so dev and tests stay untouched.
initAnalytics();

const rootEl = document.getElementById('root')!;
const tree = (
  <StrictMode>
    <CrashScreen>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </CrashScreen>
  </StrictMode>
);
// Prerendered public routes ship their markup; everything else starts empty.
if (rootEl.hasChildNodes()) hydrateRoot(rootEl, tree);
else createRoot(rootEl).render(tree);
